import { BASE_URL, REPORT, ERROR_MSG, API_GATEWAY_KEY } from "./Constants";
import Cookies from "js-cookie";

export const fetchReportData = async (reportName, startDate, endDate) => {
  let response = await fetch(
    `${BASE_URL}${REPORT}/${reportName}?startDate=${startDate}&endDate=${endDate}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};
